import script from "./News.vue?vue&type=script&setup=true&lang=js"
export * from "./News.vue?vue&type=script&setup=true&lang=js"

import "./News.vue?vue&type=style&index=0&id=67bef18c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bef18c"]])

export default __exports__